// extracted by mini-css-extract-plugin
module.exports = {"diagramLegend":"styles_diagramLegend__1NsLJ"};